<template>
	<AmeliproCard
		no-card-header
		:card-title="cardTitle"
	>
		<template #default>
			<p class="mb-0">
				{{ cardContent }}
			</p>
		</template>
	</AmeliproCard>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	@Component<RecapitulatifGarde>({})
	export default class RecapitulatifGarde extends Vue {
		cardTitle = '';
		cardContent = '';

		nombreGardes = 0;
		totalMontant = 0;
		created() {
			this.updateCardInfo();
		}

		// Pour manipuler le dom et appels api
		mounted() {
			this.$root.$on(
				'infos-recapitulatif-gardes',
				(infosRecapitulatifGardes: { nombreGardes: number; total: number }) => {
					this.nombreGardes = infosRecapitulatifGardes.nombreGardes;
					this.totalMontant = infosRecapitulatifGardes.total;
					this.updateCardInfo();
				}
			);
		}
		// méthode pour mettre à jour le titre et le contenu du card
		updateCardInfo(): void {
			this.cardContent = `${this.nombreGardes} garde${
				this.nombreGardes > 1 ? 's' : ''
			} sélectionnée${
				this.nombreGardes > 1 ? 's' : ''
			} pour un montant total de ${this.totalMontant} €`;
		}
	}
</script>
